import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Checkbox, Spin } from 'antd';

import { useDocumentReminderOptionsQuery } from '../queries/useDocumentReminderOptions';

export const DocumentReminderCheckboxGroup = ({
  loading,
  value,
  onChange,
  allowEmpty = false,
}) => {
  const documentReminderOptionsQuery = useDocumentReminderOptionsQuery();

  const options = useMemo(() => {
    const allOptions = documentReminderOptionsQuery?.data || [];
    const doNotRemindOption = allOptions.find(
      (option) =>
        option.id === 1 || option.name.toLowerCase().includes('не напоминать')
    );
    const otherOptions = allOptions.filter(
      (option) => option !== doNotRemindOption
    );
    return {
      doNotRemindOption,
      otherOptions,
    };
  }, [documentReminderOptionsQuery.data]);

  const isDoNotRemindOptionChecked = value.some(
    (id) => id === options.doNotRemindOption?.id
  );

  const onOtherOptionChange = (option) => {
    let newCheckedOptionsIds = [];
    if (value.includes(option.id)) {
      newCheckedOptionsIds = value.filter(
        (id) => id !== option.id && id !== options.doNotRemindOption.id
      );
    } else {
      newCheckedOptionsIds = [
        ...value.filter((id) => id !== options.doNotRemindOption.id),
        option.id,
      ];
    }
    onChange(
      newCheckedOptionsIds.length
        ? newCheckedOptionsIds.sort()
        : allowEmpty
        ? []
        : [options.doNotRemindOption.id]
    );
  };

  const onDoNotRemindOptionChanged = (e) => {
    if (e.target.checked) {
      onChange([options.doNotRemindOption.id]);
    } else if (allowEmpty) {
      onChange([]);
    }
  };

  return (
    <Spin spinning={loading || documentReminderOptionsQuery.isFetching}>
      {!documentReminderOptionsQuery.data.lenght &&
        documentReminderOptionsQuery.isFetching && (
          <div style={{ height: '32px' }}></div>
        )}
      {options.otherOptions.map((option) => (
        <div key={option.id}>
          <Checkbox
            onChange={() => onOtherOptionChange(option)}
            checked={value.includes(option.id)}
          >
            {option.name}
          </Checkbox>
        </div>
      ))}
      {options.doNotRemindOption && (
        <div>
          <Checkbox
            onChange={onDoNotRemindOptionChanged}
            checked={isDoNotRemindOptionChecked}
          >
            {options.doNotRemindOption.name}
          </Checkbox>
        </div>
      )}
    </Spin>
  );
};

DocumentReminderCheckboxGroup.propTypes = {
  loading: PropTypes.bool.isRequired,
};
